/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowRotateRight: {
  name: 'arrow-rotate-right';
  data: string;
} = {
  name: 'arrow-rotate-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 8C.5 3.864 3.718.5 8 .5c1.556 0 2.768.26 3.798.809.639.34 1.19.784 1.702 1.318V1a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1h1.947c-.508-.562-1.027-.993-1.62-1.309C10.482 1.741 9.444 1.5 8 1.5 4.282 1.5 1.5 4.404 1.5 8a6.5 6.5 0 1 0 13 0 .5.5 0 0 1 1 0 7.5 7.5 0 0 1-15 0Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
